var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgTopMenu = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M416.9,61.3H83.6c-18.2,0-33,14.8-33,33v333.2c0,18.2,14.8,33,33,33h333.2c18.2,0,33-14.8,33-33V94.3 C449.9,76.1,435.1,61.3,416.9,61.3z M286.2,237.1c-3.6,22.4-12,43.2-25.7,62.1c-26.2,36.4-61.8,57.4-106.3,63.1 c-4.3,0.6-8.8,0.5-13.1,0.9c-3.1,0.3-4.3-0.6-4.2-3.9c0.3-6.3,0.1-12.7,0.1-19c0-6.5,0.1-12.9,0-19.4c0-2.4,0.5-3.4,3.2-3.5 c48.6-2.2,87.2-33.6,99.1-79.9l-33,0.2l57.8-57.8l57,57L286.2,237.1z M399.6,112.7c0,15.4-12.5,27.8-27.8,27.8H139.4 c-15.4,0-27.8-12.5-27.8-27.8V90.2h288V112.7z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTopMenu, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/top_menu.db8c0aa4.svg";
export { ForwardRef as ReactComponent };